import { useMutation } from '@apollo/client';
import { useSnackbar } from '@upheal/design-system/vendor/notistack';
import { captureException } from '@upheal/shared/utils/sentry';
import { CreateCustomerPortalSessionToChangePlanDocument } from '@upheal/graphql/definitions/customer-portal/CreateCustomerPortalSessionToChangePlan.generated';

export const usePlanChangePortal = () => {
    const [portalMutation, { loading }] = useMutation(
        CreateCustomerPortalSessionToChangePlanDocument,
    );
    const { enqueueSnackbar } = useSnackbar();

    const createPlanChangeSession = async (
        planId?: string,
    ): Promise<string | undefined> => {
        const handleError = (context: object, errorTrackingMessage: string) => {
            captureException(`[billing] ${errorTrackingMessage}`, {
                ...context,
                ...(planId && { planId }),
            });
            enqueueSnackbar('Unknown error occurred. We are looking into it.', {
                variant: 'error',
            });
        };

        try {
            const response = await portalMutation({
                ...(planId && { variables: { newPlanId: planId } }),
            });

            if (!response.data?.createCustomerPortalSessionToChangePlan?.url) {
                handleError(
                    { data: response },
                    'Plan change portal mutation returned no data',
                );
                return;
            }

            return response.data.createCustomerPortalSessionToChangePlan.url;
        } catch (error) {
            handleError(
                { error },
                'Plan change portal session creation failed',
            );
            return;
        }
    };

    return {
        createPlanChangeSession,
        loading,
    };
};
